import {Injectable} from '@angular/core';
import {ToolbarItemColoringInterface} from './toolbar-item-coloring-factory.service';
import {ToolbarItemAbstractColoringService} from './toolbar-item-abstract-coloring.service';

@Injectable()
export class ToolbarItemColoringService extends ToolbarItemAbstractColoringService implements ToolbarItemColoringInterface {

}
